export function isSupport() {
  return window.location.hostname.indexOf('support') > -1;
}

export default isSupport;
